export default function trainingDocumentDirective() {
  console.log('app.components.support.trainingDocumentDirective registered');
  return {
    template: require('./training-document.html'),
    controller: 'TrainingDocumentController',
    controllerAs: 'trainingDocumentVM',
    bindToController: true,
    scope: {
      media: '=',
      filterText: '=',
    },
    replace: true,
  };
}
